<div class="form-modal" style="width: 700px" *ngIf="form">
    <h1 mat-dialog-title>{{ 'EMAIL' | translate }} {{this.processNumber}}</h1>
    <div mat-dialog-content>
      <form [formGroup]="form" class="form-horizontal modal-dialog-custom">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 no-padding">
            <!-- assunto -->
            <div class="col-lg-12 col-md-12 col-sm-12" *ngIf="data && data.Has_subject">
              <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': (formErrors && formErrors.Subject) || !form.controls.Subject.valid}">
                <mat-label>{{ 'SUBJECT' | translate}}</mat-label>
                <input matInput formControlName="Subject">
              </mat-form-field>
              <span *ngIf="formErrors.Subject" class="field-validation-valid text-danger" [translate]>{{
                formErrors.Subject }}</span>
            </div>
            <!-- endereços de destino-->
            <div class="col-lg-12 col-md-12 col-sm-12">
              <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': (formErrors && formErrors.Emails)}">
                <mat-label>{{ 'EMAILS_SEPERATED' | translate}}</mat-label>
                <input matInput formControlName="Emails">
              </mat-form-field>
              <span *ngIf="formErrors.Emails" class="field-validation-valid text-danger" [translate]>{{ formErrors.Emails
                }}</span>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12">
                <table class="table table-bordered display">
                    <thead>
                        <tr>
                            <th></th>
                            <th>
                                <strong>{{ 'DOCUMENT' | translate }}</strong>
                            </th>
                            <th>
                                <strong>{{ 'VERSION' | translate }}</strong>
                            </th>
                            <th>
                                <strong>{{ 'STATUS' | translate }}</strong>
                            </th>
                            <th>
                                <strong>{{ 'N_DOCUMENT' | translate }}</strong>
                            </th>
                        </tr>
                        <tr *ngFor="let document of documents; let i = index" [ngSwitch]="1">
                            <th>
                                <mat-checkbox [checked]="isChecked(document.ID)" (change)="toggleCheck(document)"></mat-checkbox>
                            </th>
                            <th class="vertical-middle">{{document.DocumentType}}</th>
                            <th class="vertical-middle">{{document.DocumentVersion}}</th>
                            <th class="vertical-middle">{{document.DocumentState}}</th>
                            <th class="vertical-middle">{{document.DocumentNumber}}</th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
              </div>
            <div class="col-lg-12 col-md-12 col-sm-12 spacer-bottom-xs"></div>
  
          </div>
        </div>
      </form>
    </div>
    <div mat-dialog-actions>
      <div class="full-width text-right">
        <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}" (click)="dialogRef.close(null)">
          <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
        </button>
        <button type="button" class="btn btn-primary" title="{{'BUTTON.SAVE' | translate}}" (click)="save()" [disabled]="!form.valid">
          <i class="fas fa-paper-plane"></i>&nbsp;{{'BUTTON.SEND' | translate}}
        </button>
      </div>
    </div>
  </div>